import { DateTime } from 'luxon';

import { compress as lzStringCompress, decompress as lzStringDecompress } from 'lz-string';

const localStorageKey = 'crmAppState';
const storeDelay = 400; // 0.4 seconds
const showDebuggingOutput = true;

let stateToSave = null;
let timeOfLastSaveRequest = 0;

export const saveStateToLocalStorage = (state) => {
  timeOfLastSaveRequest = DateTime.now().toMillis();
  if (showDebuggingOutput) {
    console.log(`got saveStateToLocalStorage() call at ${timeOfLastSaveRequest}`);
  }
  stateToSave = state;
  setTimeoutToSave(timeOfLastSaveRequest);
};

const setTimeoutToSave = (time) => {
  setTimeout(() => delayedSave(time), storeDelay);
};

const delayedSave = (time) => {
  if (time === timeOfLastSaveRequest) {
    if (showDebuggingOutput) {
      const now = DateTime.now().toMillis();
      console.log(`at ${now} got delayedSave() call with matching time ${time}; so actually saving`);
    }
    timeOfLastSaveRequest = 0;
    actuallySaveStateToLocalStorage(stateToSave);
    stateToSave = null;
  } else {
    if (showDebuggingOutput) {
      const now = DateTime.now().toMillis();
      console.log(`at ${now} got delayedSave() call with NON-matching time ${time}; so skipping`);
    }
  }
};

const actuallySaveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    if (showDebuggingOutput) {
      console.log(`Storing: serializedState.length: ${serializedState.length}`);
    }
    const beforeCompression = DateTime.now().toMillis();
    const compressedState = lzStringCompress(serializedState);
    const afterCompression = DateTime.now().toMillis();
    const compressionMS = afterCompression - beforeCompression;
    if (showDebuggingOutput) {
      console.log(`Storing: compressedState.length: ${compressedState.length} in ${compressionMS}ms`);
    }
    localStorage.setItem(localStorageKey, compressedState);
  } catch (err) {
    console.log(`Error in saveStateToLocalStorage(): ${err.message}`);
  }
};

export const loadStateFromLocalStorage = () => {
  try {
    const compressedState = localStorage.getItem(localStorageKey);
    if (compressedState === null) {
      return undefined;
    }
    if (showDebuggingOutput) {
      console.log(`Fetching: compressedState.length: ${compressedState.length}`);
    }
    const beforeDecompression = DateTime.now().toMillis();
    const serializedState = lzStringDecompress(compressedState);
    const afterDecompression = DateTime.now().toMillis();
    const decompressionMS = afterDecompression - beforeDecompression;
    if (showDebuggingOutput) {
      console.log(`Fetching: serializedState.length: ${serializedState.length} in ${decompressionMS}ms`);
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.log(`Error in loadStateFromLocalStorage(): ${err.message}`);
    return undefined;
  }
};
